import { render, staticRenderFns } from "./mb-download.vue?vue&type=template&id=afd8a5f0&"
import script from "./mb-download.vue?vue&type=script&lang=js&"
export * from "./mb-download.vue?vue&type=script&lang=js&"
import style0 from "./mb-download.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports